var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailSendSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 125,
    viewBox: "0 0 132 125",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.439 53.6C131.439 57.5177 129.652 61.2213 126.585 63.6592L65.9998 111.829L5.41436 63.6592C3.88106 62.4398 2.66808 60.9046 1.83725 59.1849C1.00732 57.4642 0.560547 55.5588 0.560547 53.6C0.560547 51.6069 1.42001 49.6139 3.13973 48.2422L61.7248 1.49613C64.2256 -0.498711 67.7741 -0.498711 70.2748 1.49613L128.86 48.2422C130.58 49.6139 131.439 51.607 131.439 53.6Z",
    fill: "url(#paint0_radial_790_61775)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.439 53.6C131.439 57.5177 129.652 61.2213 126.585 63.6592L65.9998 111.829L5.41436 63.6592C3.88106 62.4398 2.66808 60.9046 1.83725 59.1849C1.00732 57.4642 0.560547 55.5588 0.560547 53.6C0.560547 51.6069 1.42001 49.6139 3.13973 48.2422L61.7248 1.49613C64.2256 -0.498711 67.7741 -0.498711 70.2748 1.49613L128.86 48.2422C130.58 49.6139 131.439 51.607 131.439 53.6Z",
    fill: "url(#paint1_radial_790_61775)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.439 53.6C131.439 57.5177 129.652 61.2213 126.585 63.6592L65.9998 111.829L5.41436 63.6592C3.88106 62.4398 2.66808 60.9046 1.83725 59.1849C1.00732 57.4642 0.560547 55.5588 0.560547 53.6C0.560547 51.6069 1.42001 49.6139 3.13973 48.2422L61.7248 1.49613C64.2256 -0.498711 67.7741 -0.498711 70.2748 1.49613L128.86 48.2422C130.58 49.6139 131.439 51.607 131.439 53.6Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.439 53.6C131.439 57.5177 129.652 61.2213 126.585 63.6592L65.9998 111.829L5.41436 63.6592C3.88106 62.4398 2.66808 60.9046 1.83725 59.1849C1.00732 57.4642 0.560547 55.5588 0.560547 53.6C0.560547 51.6069 1.42001 49.6139 3.13973 48.2422L61.7248 1.49613C64.2256 -0.498711 67.7741 -0.498711 70.2748 1.49613L128.86 48.2422C130.58 49.6139 131.439 51.607 131.439 53.6Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.834 111.028H17.166V16.6933C17.166 14.4286 19.0019 12.5928 21.2665 12.5928H110.734C112.998 12.5928 114.834 14.4286 114.834 16.6933V111.028H114.834Z",
    fill: "url(#paint2_linear_790_61775)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.439 53.5996V112.373C131.439 119.346 125.786 125 118.813 125H13.187C6.21376 125 0.560547 119.346 0.560547 112.373V53.5996C0.560547 55.5927 1.42001 57.5856 3.13973 58.9574L57.3898 102.244L61.7248 105.703C64.2256 107.697 67.7741 107.697 70.2748 105.703L74.6097 102.244L128.86 58.9574C130.58 57.5857 131.439 55.5927 131.439 53.5996Z",
    fill: "url(#paint3_radial_790_61775)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.439 53.5996V112.373C131.439 119.346 125.786 125 118.813 125H13.187C6.21376 125 0.560547 119.346 0.560547 112.373V53.5996C0.560547 55.5927 1.42001 57.5856 3.13973 58.9574L57.3898 102.244L61.7248 105.703C64.2256 107.697 67.7741 107.697 70.2748 105.703L74.6097 102.244L128.86 58.9574C130.58 57.5857 131.439 55.5927 131.439 53.5996Z",
    fill: "url(#paint4_radial_790_61775)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3893 40.8425C87.137 37.0998 84.036 34.211 80.0865 32.1761C76.1367 30.1416 71.6047 29.124 66.4911 29.124C62.487 29.124 58.8204 29.7825 55.4908 31.0989C52.1614 32.4158 49.2778 34.2871 46.8408 36.7132C44.4034 39.1399 42.5265 42.0231 41.2102 45.3633C39.8933 48.7039 39.2354 52.3975 39.2354 56.4451V56.4778C39.2354 60.8517 39.9208 64.7362 41.2917 68.1309C42.6627 71.5257 44.6049 74.3931 47.1183 76.732C49.6317 79.0711 52.5858 80.8449 55.9805 82.0526C59.3753 83.2604 63.1072 83.8642 67.1767 83.8642C71.5068 83.8642 75.2393 83.3092 78.3729 82.1995V77.4338C77.1759 77.9341 75.582 78.3259 73.5908 78.6089C71.5997 78.8915 69.5377 79.0333 67.4052 79.0333C63.0094 79.0333 59.098 78.1683 55.6705 76.4383C52.2432 74.7082 49.5446 72.1622 47.5754 68.8001C45.6056 65.438 44.6213 61.3527 44.6213 56.5431V56.5104C44.6213 53.181 45.1486 50.129 46.2044 47.3544C47.2596 44.5799 48.7504 42.1864 50.6764 40.1733C52.6022 38.1607 54.8759 36.6102 57.4985 35.5218C60.1205 34.4339 62.9986 33.8897 66.1322 33.8897C70.397 33.8897 74.1238 34.717 77.312 36.3705C80.4996 38.0245 82.9754 40.3691 84.738 43.4048C86.5006 46.4405 87.382 50.0474 87.382 54.2256V54.2582C87.382 58.0232 86.8868 60.8681 85.8969 62.794C84.9064 64.7198 83.6064 65.6828 81.9962 65.6828C80.7772 65.6828 79.7929 65.1499 79.0421 64.0834C78.2913 63.0174 77.916 61.4068 77.916 59.2523V43.5843H72.3669V47.6318H72.1058C71.4963 46.1956 70.4625 45.0532 69.0048 44.2044C67.5466 43.3557 65.9365 42.9314 64.1738 42.9314C61.9756 42.9314 60.0283 43.5082 58.331 44.6614C56.6336 45.8151 55.3004 47.4089 54.3324 49.4434C53.3638 51.4784 52.8798 53.8337 52.8798 56.5103V56.543C52.8798 59.3288 53.3531 61.7657 54.2997 63.8547C55.2463 65.9438 56.5683 67.5651 58.2657 68.7183C59.9631 69.8721 61.943 70.4484 64.2065 70.4484C66.2736 70.4484 68.1015 69.9643 69.6902 68.9958C71.2784 68.0278 72.4648 66.5533 73.2482 64.5729H73.542L73.7051 64.9646C74.3141 66.5752 75.3046 67.9243 76.6756 69.0122C78.0465 70.1006 79.7545 70.6443 81.8003 70.6443C83.8893 70.6443 85.7607 70.0134 87.4147 68.7511C89.0682 67.4893 90.3738 65.6287 91.3316 63.1693C92.2889 60.7104 92.7678 57.7074 92.7678 54.1602V54.1275C92.7677 49.014 91.6417 44.5855 89.3893 40.8425ZM72.1056 56.6409C72.1056 59.2962 71.4904 61.4123 70.2613 62.9898C69.0317 64.5678 67.3833 65.3563 65.3162 65.3563C64.0105 65.3563 62.8732 65.0029 61.9051 64.2955C60.9366 63.5886 60.1914 62.5874 59.6691 61.2924C59.1467 59.9979 58.8857 58.4363 58.8857 56.6083V56.5756C58.8857 54.7696 59.1468 53.2247 59.6691 51.9405C60.1914 50.6567 60.9365 49.6719 61.9051 48.9863C62.8732 48.3008 64.032 47.9581 65.3814 47.9581C67.4052 47.9581 69.0317 48.7364 70.2613 50.292C71.4904 51.8481 72.1056 53.9427 72.1056 56.5755V56.6409Z",
    fill: "white",
    fillOpacity: 0.19
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_790_61775",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.3498 16.2071) rotate(90) scale(100.484 117.601)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37E500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CC62B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_790_61775",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(32.1482 95.3346 -117.083 44.7286 43.3243 17.2894)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_790_61775",
    x1: 66.0001,
    y1: 12.5928,
    x2: 66.0001,
    y2: 111.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43434A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_790_61775",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.3498 63.9474) rotate(90) scale(64.1566 117.601)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37E500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CC62B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_790_61775",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(32.1482 60.8689 -117.083 28.5582 43.3243 64.6385)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSendSuccess);
export default __webpack_public_path__ + "static/media/mail-send-success.929292c9aa4aac6e0a14245f99496276.svg";
export { ForwardRef as ReactComponent };